import { theme } from '@kido/ui';

const { dark } = theme;

export default dark;
